import React, { useEffect, useState } from "react";
import Header from "@components/shared/header/Header";
import Footer from "@components/shared/footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import initiateMetaEventFire from "@utils/metaEvents";
//import { LineWave } from 'react-loader-spinner'
import { useMediaQuery } from "react-responsive";
type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout = (props) => {
  const { children } = props;
  const [isLoadfadeSection, toggleFadeSection] = useState(false);
  const location = useLocation();

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const navigate = useNavigate(); // ✅ ADD this line

  useEffect(() => {
    const path = location.pathname;
    const lowercasePath = path.toLowerCase();

    // Always redirect to lowercase first
    if (path !== lowercasePath) {
      navigate(lowercasePath, { replace: true });
      return;
    }

    // List of valid base routes
    const baseRoutes = [
      "/kwikcheckoutcod",
      "/kwikcheckout",
      "/kwikcheckoutapp/t&c",
      "/oneclickcheckout",
      "/ke-international",
      "/kwikengage-india",
      "/woocommerce-checkout",
      "/kwikengage-uk-pricing",
      "/kwikengage-pricing",
    ];

    // Check for matching base path
    const matchedBase = baseRoutes.find((base) =>
      new RegExp(`^${base}/?$`).test(lowercasePath)
    );

    if (matchedBase && lowercasePath !== matchedBase) {
      navigate(matchedBase, { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    window.process = {
      ...window.process,
    };
    toggleFadeSection(false);
    setTimeout(() => {
      toggleFadeSection(true);
    }, 3000);
  }, [location]);

  // useEffect(() => {
  // 	initiateMetaEventFire();
  // 	// This will ensure the event is fired only once per page
  // }, [location.pathname]);

  return (
    <>
      {location.pathname !== "/kwikcheckout" &&
        location.pathname !== "/oneclickcheckout" &&
        location.pathname !== "/ke-international" &&
        location.pathname !== "/kwikengage-india" &&
        location.pathname !== "/woocommerce-checkout" &&
        location.pathname !== "/kwik-pricing" &&
        location.pathname !== "/checkout1.0" &&
        location.pathname !== "/checkout2.0" &&
        location.pathname !== "/custom-checkout" &&
        location.pathname !== "/kwikengage-pricing" &&
        location.pathname !== "/migrate-ind" &&
        location.pathname !== "/kwikengage-uk-pricing" &&
        (location.pathname !== "/kwikcheckoutcod" || !isMobile) && (
          <Header location="{pathname:'/'}" />
        )}
      <>
        {/* <div className='main'> */}
        {children}
        {/* </div> */}
      </>
      {isLoadfadeSection &&
        location.pathname !== "/oneclickcheckout" &&
        location.pathname !== "/ke-international" &&
        location.pathname !== "/kwikengage-india" &&
        location.pathname !== "/woocommerce-checkout" &&
        location.pathname !== "/kwik-pricing" &&
        location.pathname !== "/checkout1.0" &&
        location.pathname !== "/checkout2.0" &&
        location.pathname !== "/custom-checkout" &&
         location.pathname !== "/migrate-ind" &&
        location.pathname !== "/kwikengage-pricing" &&
        location.pathname !== "/kwikengage-uk-pricing" && <Footer />}
    </>
  );
};
export default MainLayout;
